export default "__VITE_ASSET__C$cYtvhM__"